import { Package } from '@frontend/package/types';
import { ScreenTrigger, ScreenType, Step } from '@frontend/wizard/types';

import { SERIAL_CONFIRM_OPEN_SLOTS_SCREEN_KEY, getCompletedOpenSlotPackageIds, getNextSerialPackage } from '../utils/colli-open-slot-context';

interface ResolveSerialProcessContinueArgs {
    steps: Step[];
    processScreenType: string | undefined;
    wizardData: Record<string, unknown> | undefined;
    updatePackage: (pkg: Package) => void | Promise<void>;
}

/**
 * After singular process continue: if serial confirm left pending packages,
 * advance to the next package and return SUBMIT_FALSE; otherwise SUBMIT/SUBMIT_TRUE.
 */
export async function resolveSerialProcessContinueStep(args: ResolveSerialProcessContinueArgs): Promise<Step | undefined> {
    const screenType = args.processScreenType;
    if (!screenType) return undefined;

    const submitStep =
        args.steps.find((step) => step.screen === screenType && step.trigger === ScreenTrigger.SUBMIT) ??
        args.steps.find((step) => step.screen === screenType && step.trigger === ScreenTrigger.SUBMIT_TRUE);
    const falseStep = args.steps.find((step) => step.screen === screenType && step.trigger === ScreenTrigger.SUBMIT_FALSE);

    const serialScreen = args.wizardData?.[SERIAL_CONFIRM_OPEN_SLOTS_SCREEN_KEY] as ScreenType | undefined;
    const packages = (args.wizardData?.packages as Package[] | undefined) ?? [];
    const completedIds = getCompletedOpenSlotPackageIds(args.wizardData);
    const nextPackage = getNextSerialPackage(packages, completedIds);

    if (serialScreen && falseStep && nextPackage) {
        await args.updatePackage(nextPackage);
        return falseStep;
    }

    return submitStep;
}
